import { useState } from 'react';
import { Calculator } from 'lucide-react';
import { Button } from '../../../tailwind/button';
import { cn } from '../../../../lib/utils';
import { ESTIMATE_CREDIT_COST_LABEL } from '../../../../utils/wallet/walletConstants';
import { CostCalculatorModal } from './modals/CostCalculatorModal';

export function EstimateCreditCostButton({
  className,
  variant = 'outline',
  ...buttonProps
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant={variant}
        className={cn('gap-2', className)}
        onClick={() => setOpen(true)}
        {...buttonProps}
      >
        <Calculator className="h-4 w-4" />
        {ESTIMATE_CREDIT_COST_LABEL}
      </Button>
      <CostCalculatorModal open={open} onOpenChange={setOpen} />
    </>
  );
}
